
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/rabbitmq",
      function () {
        return require("private-next-pages/destinations/rabbitmq.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/rabbitmq"])
      });
    }
  